var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"col-sm-12 col-md-6"})]),_c('hr',{staticClass:"mb-5"})])}
var staticRenderFns = []

export { render, staticRenderFns }